module.exports = __webpack_public_path__ + "static/media/book12.c64b236b.jpg";